// extracted by mini-css-extract-plugin
module.exports = {"imageGroupContainer":"AppBadges__imageGroupContainer___22w0G","fluid":"AppBadges__fluid___2R0oX"};